import * as React from 'react';
import { TopModel } from '@goldwasserexchange/react-topmodel';
import { DomTextSnippetContainer } from './components';
export var textSnippetDefaultDomTopModelsObject = {
    TextSnippetContainer: (React.createElement(TopModel, { name: "TextSnippetContainer" }, DomTextSnippetContainer)),
};
